import React from "react";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "uzivatelInfo",
  placeholderText: "0",
  content: ({ val }) => (
    <>
      <span className="b2b-UzivatelInfo-jmeno">{val.jmeno}</span>
      <span className="b2b-UzivatelInfo-prijmeni">{val.prijmeni}</span>
      {val.email.split(",").map(mail => (
        <span key={mail} className="b2b-UzivatelInfo-email">
          {mail}
        </span>
      ))}
      <span className="b2b-UzivatelInfo-telefon">{val.telefon}</span>
    </>
  )
});
